import React, { useEffect, useState, useCallback } from 'react';
import Reveal from '../components/Reveal';
import usePageTitle from '../hooks/usePageTitle';
import { images, testimonials as mockTestimonials, booking } from '../mock';
import { useBooking } from '../context/BookingContext';
import { Quote, Star, ArrowRight } from 'lucide-react';
import { getTestimonials } from '../api';

const Testimonials = () => {
  usePageTitle('Testimonials');
  const { openBooking } = useBooking();
  const [items, setItems] = useState(mockTestimonials);

  const loadTestimonials = useCallback(() => {
    getTestimonials()
      .then((data) => { if (Array.isArray(data) && data.length) setItems(data); })
      .catch(() => {});
  }, [setItems]);

  useEffect(() => { loadTestimonials(); }, [loadTestimonials]);

  return (
    <main>
      <section className="relative pt-40 pb-24">
        <div className="absolute inset-0">
          <img src={images.leadershipMeeting} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[linear-gradient(to_right,#241033_0%,rgba(36,16,51,0.93)_52%,rgba(67,38,94,0.45)_100%)]" />
        </div>
        <div className="relative max-w-[1280px] mx-auto px-6">
          <Reveal>
            <div className="eyebrow text-silver mb-5">Testimonials</div>
            <h1 className="font-display text-5xl md:text-6xl text-white font-medium leading-tight max-w-3xl mb-6">
              Momentum that moves people to action.
            </h1>
            <p className="text-[#D9CEE6] font-light text-lg max-w-2xl">
              The words of leaders, founders, and professionals who chose clarity — and moved forward with intention.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-24 bg-[#FBFAF8]">
        <div className="max-w-[1280px] mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((t, i) => (
              <Reveal key={t.id || t.name} delay={(i % 3) * 90}>
                <div className="card-lift bg-white rounded-sm p-8 h-full flex flex-col border-t-2 border-[#43265E]">
                  <Quote className="w-8 h-8 text-[#D9CEE6] mb-5" strokeWidth={1} />
                  <div className="flex gap-1 mb-5">
                    {Array.from({ length: t.rating || 5 }).map((_, s) => (
                      <Star key={s} className="w-4 h-4 text-[#43265E] fill-[#43265E]" strokeWidth={1} />
                    ))}
                  </div>
                  <p className="font-display text-xl text-[#241033] leading-relaxed italic flex-1">“{t.quote}”</p>
                  <div className="mt-7 pt-6 border-t border-[#EDE8F2]">
                    <div className="text-[#241033] font-medium">{t.name}</div>
                    <div className="text-sm text-[#7E5C9E] font-light tracking-luxe uppercase mt-1">{t.context}</div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#F4F1EC]">
        <div className="max-w-[900px] mx-auto px-6 text-center">
          <Reveal>
            <h2 className="font-display text-4xl md:text-5xl text-[#241033] font-medium mb-6">Ready to write your next chapter?</h2>
            <p className="text-[#4A4453] font-light text-lg mb-10">Let us find the clarity, alignment, and strategy to move you forward.</p>
            <button onClick={() => openBooking(booking.clarityUnpacked, 'Clarity Unpacked')} className="btn-plum rounded-full px-10 py-4 text-sm tracking-luxe uppercase inline-flex items-center gap-2">
              Book Your Session <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
            </button>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default Testimonials;
